import styled from 'styled-components';
export var StyledPortal = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPortal",
  componentId: "core-12_21_0__sc-15o1h2-0"
})(["left:0;pointer-events:none;position:fixed;top:0;> *{pointer-events:all;}"]);
//# sourceMappingURL=Portal.styles.js.map